import { createActions } from 'redux-actions'

export const INIT_COUPON_INFO = "INIT_COUPON_INFO";

export const REQUEST_COUPON_START = "REQUEST_COUPON_START";
export const REQUEST_COUPON_SUCCESS = "REQUEST_COUPON_SUCCESS";
export const REQUEST_COUPON_FAIL = "REQUEST_COUPON_FAIL";

export const REQUEST_COUPON_HISTORY_START = "REQUEST_COUPON_HISTORY_START";
export const REQUEST_COUPON_HISTORY_SUCCESS = "REQUEST_COUPON_HISTORY_SUCCESS";
export const REQUEST_COUPON_HISTORY_FAIL = "REQUEST_COUPON_HISTORY_FAIL";

export const REQUEST_COUPON_DETAIL_START = "REQUEST_COUPON_DETAIL_START";
export const REQUEST_COUPON_DETAIL_SUCCESS = "REQUEST_COUPON_DETAIL_SUCCESS";
export const REQUEST_COUPON_DETAIL_FAIL = "REQUEST_COUPON_DETAIL_FAIL";

export const IMPORT_MASTER_COUPON_START = "IMPORT_MASTER_COUPON_START";
export const IMPORT_MASTER_COUPON_SUCCESS = "IMPORT_MASTER_COUPON_SUCCESS";
export const IMPORT_MASTER_COUPON_FAIL = "IMPORT_MASTER_COUPON_FAIL";

export const {

  initCouponInfo,

  requestCouponStart,
  requestCouponSuccess,
  requestCouponFail,

  requestCouponHistoryStart,
  requestCouponHistorySuccess,
  requestCouponHistoryFail,

  requestCouponDetailStart,
  requestCouponDetailSuccess,
  requestCouponDetailFail,

  importMasterCouponStart,
  importMasterCouponSuccess,
  importMasterCouponFail,

} = createActions({

  [INIT_COUPON_INFO]: (req) => ({ req }),

  [REQUEST_COUPON_START]: (req) => ({ ...req }),
  [REQUEST_COUPON_SUCCESS]: (res) => ({ res }),
  [REQUEST_COUPON_FAIL]: (res) => ({ res }),

  [REQUEST_COUPON_HISTORY_START]: (req) => ({ ...req }),
  [REQUEST_COUPON_HISTORY_SUCCESS]: (res) => ({ res }),
  [REQUEST_COUPON_HISTORY_FAIL]: (res) => ({ res }),

  [REQUEST_COUPON_DETAIL_START]: (req) => ({ ...req }),
  [REQUEST_COUPON_DETAIL_SUCCESS]: (res) => ({ res }),
  [REQUEST_COUPON_DETAIL_FAIL]: (res) => ({ res }),

  [IMPORT_MASTER_COUPON_START]: (req) => ({ ...req }),
  [IMPORT_MASTER_COUPON_SUCCESS]: (res) => ({ res }),
  [IMPORT_MASTER_COUPON_FAIL]: (res) => ({ res }),

})


